import type { Editor } from "@tiptap/react"

// Characters kept on each side of the selection. The backend still caps
// context_text at 500 (CaptureLessonVocabulary) — the most this can produce is
// an 80-char selection plus 2 × 150 = 380.
export const CAPTURE_CONTEXT_RADIUS = 150

// The AI context for a classroom capture: the sentence around the selection —
// the selected text's own textblock (paragraph/heading), cut to
// CAPTURE_CONTEXT_RADIUS characters before the selection start and after its
// end, whitespace-trimmed. Never the first 500 characters of the document
// (#825 phase 2). Empty selection or a non-textblock parent → "".
export function captureContextFor(editor: Editor): string {
  const { from, to, $from } = editor.state.selection
  if (from === to) return ""
  const parent = $from.parent
  if (!parent.isTextblock) return ""
  const parentStart = $from.start()
  const text = parent.textContent
  const s = from - parentStart
  const e = to - parentStart
  return text
    .slice(Math.max(0, s - CAPTURE_CONTEXT_RADIUS), Math.min(text.length, e + CAPTURE_CONTEXT_RADIUS))
    .trim()
}
